import React from 'react'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'

const CommonSelectBox = ({ label, value, setValue, data, id, name, disabled }) => {

    return (
        <div>
            <FormControl size="small" fullWidth disabled={disabled}>
                <InputLabel>{label}</InputLabel>
                <Select
                    label={label}
                    value={value}
                    onChange={(event) => {
                        setValue(event.target.value);
                    }}
                >

                    {data?.map((item) => (
                        <MenuItem key={item[id]} value={item[id]}>
                            {item[name]}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    )
}

export default CommonSelectBox